import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 14\" id=\"icon-close\"><path d=\"M12.762 13.01c.303-.303.32-.8.03-1.09l-4.93-4.93 4.893-4.894a.793.793 0 0 0 .007-1.101.788.788 0 0 0-1.101.007L6.767 5.896 1.831.96C1.541.67 1.044.687.741.99c-.308.308-.32.799-.029 1.09l4.936 4.935-4.894 4.894c-.297.297-.314.805-.013 1.107.296.296.81.284 1.107-.013L6.742 8.11l4.93 4.93c.29.29.782.28 1.09-.029Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol